// Internal modules
import type { CountryCodes } from '@/generated/graphql';
import { CI, features, getToken, postToMerchantForOldIncontext } from '@/lib';
import { logger, STATE_NAME, TRANSITION_NAME } from '@/lib/logger';
import type { ActionCreator } from 'easy-peasy';

const getFooterLegalLinks = (
  country: CountryCodes,
  region: string | null,
): string[] => {
  const footerLinksMap = features.get('footerLinks');
  return (
    // @ts-expect-error
    footerLinksMap[country] || footerLinksMap[region] || footerLinksMap.DEFAULT
  );
};

const getFooterLegalContent = (): string => {
  /* this is temporary (ramp elmo waiting for legal/compliance green light)
   the content will be then set into legalFooter.entity and this check will be removed */
  if (features.isActive('shouldShowNewPhilippinesFooterDisclaimer')) {
    return 'legalFooter.issued3PlLicensePH';
  }

  return 'legalFooter.entity';
};

const handleReturnToMerchantLinkClick = (
  e: React.MouseEvent,
  toggleIsPageLoading: ActionCreator<boolean>,
  isFormSubmitting: boolean,
  intent: string,
  cancelUrl: string,
): void => {
  e.preventDefault();

  if (isFormSubmitting) {
    return;
  }

  CI.endAll(CI.Status.Cancel, CI.ErrorReason.User);

  toggleIsPageLoading(true);
  const { cancelAndRtm } = TRANSITION_NAME;

  logger.fpti(`weasley_${cancelAndRtm}`, {
    state_name: STATE_NAME.backToMerchant,
    transition_name: cancelAndRtm,
  });

  logger.metric('GUEST_SIGNUP.CANCEL', {
    dimensions: {
      outcome: 'Cancel and return to merchant',
      outcomeReason: 'return link clicked',
      state_name: STATE_NAME.backToMerchant,
      transition_name: cancelAndRtm,
    },
  });

  logger.flushThen(() => {
    if (window.xprops) {
      const token = getToken();
      const data = {
        cancelUrl,
        intent: intent?.toLowerCase(),
        orderID: token,
        paymentToken: token,
      };

      window.xprops.onCancel?.(data);
      return;
    }

    // for old checkout.js integration send post message
    const didPostToMerchantForOldIncontext =
      postToMerchantForOldIncontext(cancelUrl);
    if (didPostToMerchantForOldIncontext) {
      return;
    }

    window.location.assign(cancelUrl);
  });
};

export {
  getFooterLegalLinks,
  getFooterLegalContent,
  handleReturnToMerchantLinkClick,
};
